import { Link } from 'react-router-dom'
import 'primeicons/primeicons.css'

export default function HeroBannerAuthenticated() {

  return (
    <section className="relative overflow-hidden py-20 md:py-32 flex items-center min-h-[80vh]">
      {/* Content Overlay - Background sẽ dùng từ HomePage fixed background */}
      <div className="container mx-auto relative z-10 px-4 py-12">
        <div className="max-w-5xl mx-auto text-center">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <img
                src="/images/logo.png"
                alt="SAIGON FC Logo"
                width={120}
                height={120}
                className="object-contain"
              />
            </div>
          </div>

          {/* Main Headlines */}
          <div className="mb-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-2 leading-tight">
              <span className="text-gold-400">TẬP HÔM NAY</span>
            </h1>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-white">
              MẠNH HƠN NGÀY MAI
            </h2>
          </div>

          {/* Secondary Text */}
          <p className="text-base md:text-lg text-white mb-10 leading-relaxed max-w-2xl mx-auto">
            Điểm danh mỗi ngày, leo Top BXH và nhận huy hiệu độc quyền từ SaiGon FC
          </p>

          {/* CTA Button */}
          <Link
            to="/checkin"
            className="inline-flex items-center justify-center gap-3 px-8 py-4 md:px-10 md:py-4 bg-gold-gradient text-black font-bold text-lg md:text-xl rounded-lg shadow-lg shadow-gold-500/50 hover:shadow-xl hover:shadow-gold-500/70 transition-all duration-300 transform hover:scale-105 active:scale-95"
          >
            <i className="pi pi-calendar text-2xl"></i>
            <span>ĐIỂM DANH HÔM NAY</span>
          </Link>
        </div>
      </div>
    </section>
  )
}

